import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { PdfFileInfo } from '../models/pdfFileInfo.model';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable()
export class PdfService {
  constructor(private http: HttpClient) {}

  getPdfUrl(): Observable<Map<string, string>> {
    const pdfMap: Map<string, string> = new Map<string, string>();
    return this.http.get<PdfFileInfo[]>('assets/jsons/pdf.json').pipe(
      map(data => {
        data.forEach(fileInfo => pdfMap.set(fileInfo.language, fileInfo.url));
        return pdfMap;
      })
    );
  }

  getPdfFileName(file: string): string {
    const lastIndex = file.lastIndexOf('/');
    return file.substring(lastIndex + 1, file.length);
  }
}
